import { Component } from '@angular/core';

import { ModalAdapter } from './modal.adapter';

@Component({
  selector: 'lepi-modal-header',
  template: `
    <section class="z-10 flex justify-between w-full px-6 bg-base-100">
      <div class="flex items-center gap-3 h-16 w-full justify-between">
        <div class="flex items-center gap-3">
          <div class="w-1 h-5 bg-primary rounded-full"></div>
          <h2
            class="font-bold text-base-content text-lg md:text-xl tracking-tight">
            <ng-content />
          </h2>
        </div>
        <button
          type="button"
          (click)="close()"
          class="btn btn-ghost btn-circle btn-sm text-base-content/50 hover:text-base-content transition-colors">
          <span class="icon-[material-symbols--close] text-2xl"></span>
        </button>
      </div>
      <ng-content select="[icons]" />
    </section>
  `,
  imports: [],
})
export class ModalHeader extends ModalAdapter {}
